module.exports = __webpack_public_path__ + "img/5.55feef4d.jpg";